import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InstructorsHero } from '../components/instructors/InstructorsHero';
import { InstructorGrid } from '../components/instructors/InstructorGrid';
import { InstructorsCTA } from '../components/instructors/InstructorsCTA';
export function InstructorsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-762">
      <Header data-id="element-763" />

      <main className="pt-20" data-id="element-764">
        <InstructorsHero data-id="element-765" />
        <InstructorGrid data-id="element-766" />
        <InstructorsCTA data-id="element-767" />
      </main>

      <Footer data-id="element-768" />
    </div>;
}